import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const routes = ref([])
const backButtonProps = ref(null)

export const useNavigation = () => {
  const $route = useRoute()
  const $router = useRouter() // eslint-disable-line

  const pushRoute = route => {
    routes.value.push(route)
  }

  const popRoute = () => {
    routes.value.pop()
  }

  const navigateBack = () => {
    const matched = $route.matched
    const parentRecord = matched[matched.length - 2]
    if (parentRecord) {
      if (parentRecord.name) {
        console.log(window.history)
        // console.log($route.params)
      // console.log($router.getRoutes())
      } else {
      //
      }
    } else {
    //
    }
  }

  return {
    routes,
    backButtonProps,
    pushRoute,
    popRoute,
    navigateBack
  }
}
